'use memo'

import {
  AgxModal,
  AgxSpacer,
  AgxTypography,
  Icon_FeaturedIcon,
} from '@urbanx/agx.ui-components2'
import { useEffect } from 'react'

import './TaskCompletionConfirmationModal.scss'

interface TaskCompletionConfirmationModalProps {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
  title: string
  message: string
  autoCloseAfterMs?: number
}

const TaskCompletionConfirmationModal = ({
  isOpen,
  onOpenChange,
  title,
  message,
  autoCloseAfterMs = 1200,
}: TaskCompletionConfirmationModalProps) => {
  useEffect(() => {
    if (!isOpen || !autoCloseAfterMs) return

    const timeout = window.setTimeout(
      () => onOpenChange(false),
      autoCloseAfterMs
    )

    return () => window.clearTimeout(timeout)
  }, [autoCloseAfterMs, isOpen, onOpenChange])

  return (
    <AgxModal
      id="task-completion-confirmation-modal"
      type="dialog"
      variant="withoutDivider"
      actionButtonContainerStyle="withoutDivider"
      setIsDialogOpen={onOpenChange}
      isOpen={isOpen}
      minWidth="600px"
      content={
        <div className="taskCompletionConfirmationModal">
          <Icon_FeaturedIcon />
          <AgxSpacer
            direction="vertical"
            contentAlignment="center"
            gap="spacing-xs"
          >
            <AgxTypography
              id="task-completion-confirmation-title"
              type="body_ui_strong"
              size="medium"
              color="var(--text-primary)"
              textAlign="center"
            >
              {title}
            </AgxTypography>
            <AgxTypography
              id="task-completion-confirmation-message"
              type="body_ui"
              size="small"
              color="var(--text-secondary)"
              textAlign="center"
            >
              {message}
            </AgxTypography>
          </AgxSpacer>
        </div>
      }
    />
  )
}

export default TaskCompletionConfirmationModal
